import React, { ChangeEvent } from 'react';

interface PropType {
    name: string;
    value: number | null | undefined;
    placeholder?: string;
    hint?: string;
    step: string;
    onChange: (value: number, name: string) => void;
}

const InputNumber = (props: PropType) => {
    const val = !isNaN(Number(props.value)) ? Number(props.value) : undefined;
    return (
        <>
            <input
                type="number"
                value={val}
                onChange={(e: ChangeEvent<any>) => { props.onChange(e.currentTarget.value, props.name); }}
                className="form-control"
                placeholder={props.placeholder}
                name={props.name}
                step={props.step}
            />
            {props.hint && <span className="form-text m-b-none">{props.hint}</span>}
        </>
    );
};

export default InputNumber;



// WEBPACK FOOTER //
// ./src/components/Form/InputNumber.tsx